/**
 * Description component.
 * Displays the description of the currently focused asset in a rail.
 */
import Animation from '../../utils/helpers/opacityAnimation';
import Background from './descriptionBackground';
import Container from '../../atoms/container/descriptionContainer';
import Content from './descriptionContent';
import MainContext from '../../../../shared/components/utils/context/mainContext';
import { setDescription } from '../../../../shared/store/slices/app.slice';
import { useAppDispatch } from '../../../../shared/store/hooks';
import { useContext, useEffect } from 'react';

/**
 * Description component.
 * Displays the description of the currently focused asset in a rail.
 */
export default function Description() {
  // Hook
  const display = useDescription();

  // Render
  return display ? (
    <Animation>
      <Container>
        <Background />
        <Content />
      </Container>
    </Animation>
  ) : null;
}

/**
 * Hook to set the description of the currently focused asset in a rail.
 */
function useDescription() {
  // Dispatch
  const dispatch = useAppDispatch();

  // Context
  const { display } = useContext(MainContext);

  // Effects
  useEffect(() => {
    dispatch(setDescription(display?.description || false));
    return () => {
      dispatch(setDescription(false));
    };
  }, [display]);

  // Return values
  return display?.description;
}
